import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import featuredTourBG from '../media/newstoragebackground.jpg'; // ../media/newstoragebackground.jpg // '../media/recipespagebackground.jpg'
//import mapleBottleBG from '../media/mapleweekendbottle.jpg'
import cows1 from '../media/newbeefpic09252021.jpg'


const FeaturedTourSection = (props) => {
	const shopGiftBasketsClick = () => {
		console.log("shop gift baskets");
	}

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
		<h1>Beef for Sale!</h1>

	     <p>Patterson Farms is offering 100% grass fed beef - USDA inspected - in the store. At this time, we have hamburger and roasts - $6.00/lb.
	     	If you're interested in more beef, we can do that too! Beef is available by quarter, half, 
	     	and whole cuts. <a href="tel:8146283751">Call</a> or <Link to="/Contact">contact</Link> us today to discuss ordering your next freezer beef!</p>

		 <CowPic src={cows1}></CowPic>
		 
		{/*<LeavesImg src={require("../media/snowflake.png")}></LeavesImg>*/}
		<LeavesImg src={require("../media/leavespng1.png")}></LeavesImg>

	    {/*
	      <h1>Sale This Month</h1>
		  <p>This month, our 1 lb. bag of maple crunchies will be <ProductLink to="/Shop/sale"><u>10%</u></ProductLink> off. Don't miss out!</p>
		  
		  <ProductLink to="/Shop/sale">
			<ProductImg src={require("../media/31.jpg")}></ProductImg>
		  </ProductLink>
		  
		*/}
		  {/*
		  <BottleDiv>
			  <BottleImg src={require("../media/mapleweekendbottle.png")}>

			  </BottleImg>
			  <TextInBottleDiv>
				  <h3>Come Check Out Our Maple Weekend!</h3>
				  <p>
				   	  On March 16th & 17th, 2019, from 10am to 4pm, Patterson Farms will be participating in the
				   	  15th annual Potter / Tioga County Maple Weekend! Come join us for a fun filled 
				   	  weekend of demonstrations, tours, samples (taste testing), history, and much more!
				  </p>
			  </TextInBottleDiv>

		  </BottleDiv>
		*/}
	    </InternalContainer>
	  </FluidContainer>
	); 
};

const LeavesImg = styled.img`
	width: auto!important;
	height: auto!important;
	max-height: 40px!important;
	${media.md`max-height: 50px!important;`}
	position: absolute!important;
	left: 0;
	bottom: -5px;
`;

const CowPics = styled(Col)`
	
`;

const CowPic = styled.img`
	width: 100%;
	height: auto;
	margin: 0 auto;
	border: 5px solid sandybrown;

	${media.sm` `}
	${media.md`  `}
	${media.lg` width: 80%; `}
	${media.xl` width: 75%; `}
	${media.xxl` `}
`;

const ProductLink = styled(Link)`
	u { color: white; }
`;
const ProductImg = styled.img`
	width: 60%;
	height: auto;
	transition: all 0.5s;
	:hover { transform: translateY(6px); }
`;

const BottleDiv = styled.div`
	position: relative;

	h3 { text-align: center; }
	p { 
		text-align: left; 
		${media.sm` `}
		${media.md`  `}
		${media.lg`  `}
		${media.xl`  `}
		${media.xxl` `}
	}
`;

const TextInBottleDiv = styled.div`
	${media.sm` 
		width: 70%;
		position: absolute;
	    top: 57%;
	    left: 50%;
	    transform: translate(-50%, -50%);
	`}
	${media.md` width: 55%; top: 60%;`}
	${media.lg` width: 40%; top: 66%; `}
	${media.xl` width: 35%;`}

`;

const BottleImg = styled.img`
	display: none;

	${media.sm` width: 85%; height: auto; display: inline;`}
	${media.md` width: 70%;`}
	${media.lg` width: 52%;`}
	${media.xl` width: 45%;`}

`;


const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${featuredTourBG}); 
`;

const InternalContainer = styled(Container)`
	text-align: center;
	padding-bottom: 50px;
	h1 { 
		margin: 0 0 20px 0;
		color: white;
	}
	p, h3 {
		color: white;
	}
	a { color: sandybrown!important; }
`;


/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default FeaturedTourSection;


// WEBPACK FOOTER //
// ./src/components/FeaturedTourSection.js